import axios from "axios"
import { ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json";
import { authHeader } from "helpers/auth-header";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import { GuardarPresupuestoAsignado, GuardarPresupuestoModificado, InformacionGeneralPresupuestoGPE, PresupuestoModificadoUnidad } from "./TypesPresupuestoGPEHE";
import { downloadExcelReport } from "helpers/downloadExcelReport";

export const URL_SOLO_CONTROLLER_ASIGNACION_PRESUPUESTO = `PresupuestoHorasExtras`
export const URL_CONTROLLER_ASIGNACION_PRESUPUESTO = `${configData.SERVER_URL}PresupuestoHorasExtras`
export const URL_INFORMACION_GENERAL_ASIGNACION_PRESUPUESTO = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/InformacionGeneralAsignacion`
export const URL_GUARDAR_PRESUPUESTO = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/AsignacionPresupuesto`
export const URL_ASIGNAR_Y_NOTIFICAR_PRESUPUESTO = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/NotificarAsignacionPresupuesto`
export const URL_REPORTE_PROYECCIONES_PDF = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/ReportePDFProyeccionUnidades`
export const URL_REPORTE_PROYECCIONES_EXCEL = `${URL_SOLO_CONTROLLER_ASIGNACION_PRESUPUESTO}/ReporteExcelProyeccionUnidades`
export const URL_MODIFICAR_PRESUPUESTO = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/ModificarPresupuesto`
export const URL_MODIFICAR_PRESUPUESTO_INDIVIDUAL = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/ModificarPresupuestoIndividual`
export const URL_GUARDAR_MODIFICACION_PRESUPUESTO = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/GuardarModificacionPresupuesto`
export const URL_GUARDAR_MODIFICACION_PRESUPUESTO_INDIVIDUAL = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/GuardarModificacionPresupuestoIndividual`
export const URL_GUARDAR_VALOR_DITRIBUIR_MOD = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/GuardarValorDistribuirModificar`

export async function ObtenerInformacionUnidadesGPE(ismodificacion: boolean) {


    var respuesta: ResponseRequestGeneric<InformacionGeneralPresupuestoGPE> = {
        status: -1
    };

    try {

        const responseAxios = await axios.get((`${URL_INFORMACION_GENERAL_ASIGNACION_PRESUPUESTO}/${ismodificacion}`),
            {
                headers: authHeader()
            }
        )

        var data: InformacionGeneralPresupuestoGPE = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }

    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionGeneralPresupuestoGPE>(error)
    }

    return respuesta


}

export async function GuardarPresupuestoUnidad(informacion: GuardarPresupuestoAsignado) {


    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };

    try {

        const responseAxios = await axios.post(URL_GUARDAR_PRESUPUESTO, informacion,
            {
                headers: authHeader()
            }
        )



        respuesta = {
            status: responseAxios.status,
        }

    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }

    return respuesta


}

export async function AsignarYNotificarPresupuestoUnidad(informacion: GuardarPresupuestoAsignado) {


    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };

    try {

        const responseAxios = await axios.post(URL_ASIGNAR_Y_NOTIFICAR_PRESUPUESTO, informacion,
            {
                headers: authHeader()
            }
        )



        respuesta = {
            status: responseAxios.status,
        }

    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }

    return respuesta


}

export async function GuardarModificacionPresupuestoIndividual(informacion: PresupuestoModificadoUnidad) {


    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };

    try {
        const responseAxios = await axios.post(URL_GUARDAR_MODIFICACION_PRESUPUESTO_INDIVIDUAL, informacion,
            {
                headers: authHeader()
            }
        )

        respuesta = {
            status: responseAxios.status,
        }

    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }

    return respuesta
}

export async function ModificarPresupuestoIndividual(idEstructura: number) {
    var informacion: string = "";

    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };

    const url = `${URL_MODIFICAR_PRESUPUESTO_INDIVIDUAL}/${idEstructura}`

    try {
        const responseAxios = await axios.post(url, informacion,
            {
                headers: authHeader()
            }
        )
        respuesta = {
            status: responseAxios.status,
        }

    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}

export async function ModificarPresupuestoUnidad() {
    var informacion: string = "";

    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };

    try {

        const responseAxios = await axios.post(URL_MODIFICAR_PRESUPUESTO, informacion,
            {
                headers: authHeader()
            }
        )

        respuesta = {
            status: responseAxios.status,
        }

    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }

    return respuesta


}

export async function GuardarModificacionPresupuestoUnidad(informacion: GuardarPresupuestoModificado) {


    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };

    try {

        const responseAxios = await axios.post(URL_GUARDAR_MODIFICACION_PRESUPUESTO, informacion,
            {
                headers: authHeader()
            }
        )

        respuesta = {
            status: responseAxios.status,
        }

    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }

    return respuesta


}

export async function GuardarValorDistribuirMod(valorDistribuir: number) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    };
    try {
        const responseAxios = await axios.post(`${URL_GUARDAR_VALOR_DITRIBUIR_MOD}/${valorDistribuir}`, 0,
            {
                headers: authHeader()
            }
        )
        respuesta = {
            status: responseAxios.status,
        }
    } catch (error) {
        respuesta = hadleAxiosErrorResponse<void>(error)
    }
    return respuesta
}

export async function ObtenerReporteExcelModificacionPresupuestoGPE() {

    var URLCOMPLETA = `PresupuestoHorasExtras/ReporteExcelModificacionPresupuestoGPE`

    await downloadExcelReport(URLCOMPLETA, "REPORTE MODIFICACION PRESUPUESTO UNIDADES.xlsx")
}